import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import * as Styled from './PoweredByVelo.style';

/**
 * PoweredByVelo component - displays the Powered by Velo logo and banner
 * @param {object} props - Component props
 * @param {string} props.url - The URL to redirect to when the button is clicked
 * @component
 */
function PoweredByVelo({ url }) {
  return (
    <Styled.PoweredByVeloRoot>
      <Styled.BusinessResultsBanner>
        <Styled.BusinessResultsBannerText color="secondary" size="md">
          {' '}
          Start and protect your business with worry-free services, AI tools, and expert support.{' '}
          <Text component="span" fontWeight="bold" size="md">
            {' '}
            Starts at $0 + state fees{' '}
          </Text>
          .
        </Styled.BusinessResultsBannerText>

        <Styled.PoweredByVeloImage
          alt="Business Results Banner"
          src="/s2/raster/business-ideas-banner-isolated.png"
        />
      </Styled.BusinessResultsBanner>

      <Styled.PoweredByVeloLogoImage
        alt="Powered by ZenbusinessVelo"
        src="/s2/raster/powered-by-zb-velo.png"
      />
      {url && (
        <Styled.PoweredByVeloButton
          color="secondary"
          href={url}
          size="sm"
          target="_blank"
          variant="contained"
        >
          Get Started <Styled.ArrowForwardIcon />
        </Styled.PoweredByVeloButton>
      )}
    </Styled.PoweredByVeloRoot>
  );
}

PoweredByVelo.propTypes = {
  url: PropTypes.string
};

export default PoweredByVelo;
